import EstablishmentChoiceEntryManualEntryCompleted from "../../../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/ManualEntry/EstablishmentChoiceEntryManualEntryCompleted";
import EstablishmentChoiceEntryManualEntryPending from "../../../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/ManualEntry/EstablishmentChoiceEntryManualEntryPending";
import { MaintenanceForwardingsEstablishmentChoiceEntryStepOptions } from "../../../types/maintenanceForwardingsShowDirectiveDetails.type";

export const establishmentChoiceEntryOptions: {
  [K in MaintenanceForwardingsEstablishmentChoiceEntryStepOptions]: {
    title: string;
    description: string | undefined;
    components: {
      pending: React.ComponentType;
      completed: React.ComponentType;
    };
  }
} = {
  [MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.ManualEntry]: {
    title: 'Enviar para um único estabelecimento',
    description: 'Defina um Estabelecimentos para aceitar realizar o diagnóstico e orçamento (apenas estabelecimentos homologados para seu Equipamento)',
    components: {
      pending: EstablishmentChoiceEntryManualEntryPending,
      completed: EstablishmentChoiceEntryManualEntryCompleted,
    },
  },
}
